// import React from "react";

// function ExportReportSupport({ comment, comments }) {
//   let rank = 0;

//   return (
//     <div className="p-5">
//       <div className="d-flex justify-content-between">
//         <img width="100px" src="/sod.jpeg" />
//         <div className="text-center">
//           <h6 className="mb-0">FIGARO COFFEE SYSTEM, INC.</h6>
//         </div>
//         <img width="100px" src="/sod.jpeg" />
//       </div>
//       <table className="table table-striped">
//         <tr className="text-center">
//           <th>Name</th>
//           <th>Email</th>
//           <th>Message</th>
//           <th>Date and Time</th>
//           <th>Photo</th>
//         </tr>
//         {answers.map((answer, index) => {
//           const previous = answers[index - 1];
//           const {
//             "Product Quality Audit (1st)": product1,
//             "Product Quality Audit (2nd)": product2,
//             "Store Audit": outlet,
//             ...form
//           } = answer.form;

//           const product1Average =
//             ((product1 && product1.score / product1.total) || 0) * 100;
//           const product2Average =
//             ((product2 && product2.score / product2.total) || 0) * 100;
//           const outletAverage =
//             ((outlet && outlet.score / outlet.total) || 0) * 100;

//           //computation for final Average
//           const averages = [outletAverage, product1Average, product2Average];

//           // Remove any zeros from the array
//           const nonZeroAverages = averages.filter((avg) => avg !== 0);

//           let TotalAverage;

//           switch (nonZeroAverages.length) {
//             case 0:
//               TotalAverage = 0;
//               break;
//             case 1:
//               TotalAverage = nonZeroAverages[0];
//               break;
//             case 2:
//               TotalAverage = (nonZeroAverages[0] + nonZeroAverages[1]) / 2;
//               break;
//             case 3:
//               TotalAverage =
//                 (nonZeroAverages[0] + nonZeroAverages[1] + nonZeroAverages[2]) /
//                 3;
//               break;
//             // case 4:
//             //   TotalAverage =
//             //     (nonZeroAverages[0] +
//             //       nonZeroAverages[1] +
//             //       nonZeroAverages[2] +
//             //       nonZeroAverages[3]) /
//             //     4;
//             //   break;
//             default:
//               // Use all four averages to calculate total average
//               TotalAverage =
//                 (outletAverage + product1Average + product2Average) / 3;
//               break;
//           }

//           //
//           if (previous && previous.average === answer.average) {
//             rank--;
//           }
//           rank++;
//           return (
//             <tr className="text-center">
//               <td>{rank}</td>
//               <td>{answer.name}</td>
//               <td>{product1Average.toFixed(2)}</td>
//               <td>{product2Average.toFixed(2)}</td>
//               <td>{outletAverage.toFixed(2)}</td>
//               <td>{TotalAverage.toFixed(2)}</td>
//               <td>
//                 {answer.average >= 92.5 && (
//                   <span className="badge bg-primary">PASS</span>
//                 )}
//                 {answer.average < 92.5 && (
//                   <span className="badge bg-danger">FAIL</span>
//                 )}
//               </td>
//               <td>-</td>
//             </tr>
//           );
//         })}
//       </table>
//     </div>
//   );
// }

import React from "react";

function ExportReportSupport({ comments }) {
  let rank = 0;

  return (
    <div className="p-5">
      <div className="d-flex justify-content-between">
        <img width="100px" src="/logo.png" />
        <div className="text-center">
          <h6 className="mb-0">FIGARO COFFEE SYSTEM, INC.</h6>
          <h6 className="mb-0">Per the closed ticket report</h6>
          <h6 className="mb-0">
            Date Report -{" "}
            {new Date(comments[0]?.ticket?.createdAt).toLocaleString()}
          </h6>
        </div>
        <img width="100px" src="/logo.png" />
      </div>
      <table className="table table-striped mt-3">
        <thead>
          <tr className="text-center">
            <th>Ticket #</th>
            <th>Name</th>
            <th>Email</th>
            <th>Message</th>
            <th>Date and Time</th>
            <th>Photo</th>
          </tr>
        </thead>
        <tbody>
          {comments.map((comment, index) => {
            const { sender, content, createdAt, attachment, ticket } = comment;

            // Increment rank
            rank++;

            return (
              <tr className="text-center" key={comment.id}>
                <td>{ticket?.id}</td>
                <td>{sender?.name}</td>
                <td>{sender?.email}</td>
                <td>{content}</td>
                <td>{new Date(createdAt).toLocaleString()}</td>
                <td>
                  {attachment && attachment.length > 0 ? (
                    <img
                      src={attachment[0]} // Assuming there is one image per comment
                      alt="attachment"
                      width="50"
                    />
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ExportReportSupport;
